/**
 * Format a tracking number (or similar id) with ellipsis in the center when too long.
 * When length <= 12 returns as-is; otherwise returns first 8 chars + "..." + last 4 chars.
 */
export function formatTrackingNumberWithEllipsis(value: string, maxLength = 12, startChars = 8, endChars = 4): string {
    if (!value || value.length <= maxLength) return value;
    return `${value.substring(0, startChars)}...${value.substring(value.length - endChars)}`;
}

/**
 * This function will replace all '_' in the string with spaces and capitalize the first letter of the entire string
 * @param value
 */
export function makeHumanReadable(value: string): string {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    return value.replace(/_/g, ' ');
}

/**
 *
 * @param length
 * @returns random string of given length from a-zA-Z0-9
 */

export function getRandomString(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}
